// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAeny-FNNa8xOThFNF-Txeo9yThzb7rGMs",
  authDomain: "smart-crm-11f8a.firebaseapp.com",
  projectId: "smart-crm-11f8a",
  storageBucket: "smart-crm-11f8a.firebasestorage.app",
  messagingSenderId: "657290336410",
  appId: "1:657290336410:web:6d073ff507c5e02f11e723",
  measurementId: "G-LK3EY0CPFJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Auth
const auth = getAuth(app);

const functions = getFunctions(app);

// Connect to the emulator for local testing
if (window.location.hostname === "localhost") {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

export { firebaseConfig, db, auth, functions };
